module.exports = __webpack_public_path__ + "img/Ic_Professional-test.e880cda8.svg";